import { Grommet } from "grommet";
import React from "react";
import { Helmet } from "react-helmet";
import { transitions, positions, Provider as AlertProvider } from "react-alert";
import AlertMUITemplate from "react-alert-template-mui";
import themeVariables from "./theme";

const options = {
  position: positions.TOP_CENTER,
  timeout: 5000,
  offset: "20px",
  transition: transitions.FADE,
};

export default function SiteLayout(props) {
  return (
    <Grommet theme={themeVariables} full>
      <Helmet title="OneLink Pay">
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <style>{`
          * { box-sizing: border-box; }
          body { background: #223764; margin: 0; padding: 0; }
          main { margin: 0; padding: 0; }
          #preloading { display: none; }
        `}</style>
      </Helmet>
      <AlertProvider template={AlertMUITemplate} {...options}>
        <div style={{ minHeight: "100vh" }}>{props.children}</div>
      </AlertProvider>
    </Grommet>
  );
}
